import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TextField } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CustomizedSnackbars from "./CustomizedSnackbars";
import CopyToClipboard from "react-copy-to-clipboard";
import { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { useSelector } from "react-redux";
import QRCode from "react-qr-code";
import CryptoJS from "crypto-js";
import cogoToast from "cogo-toast";
import { UploadApi } from "../constants/Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({
  email,
  cOpen,
  setCOpen,
  cAccession,
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [pass, setPass] = useState("");
  const [show, setshow] = useState(false);
  const [modal, setModal] = useState(false);
  const [date, setDate] = React.useState("");
  const [emailToSend, setEmailToSend] = React.useState("");
  const state = useSelector((state) => state.user);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const fullScreen2 = useMediaQuery(theme.breakpoints.down("lg"));

  const SendEmail = async () => {
    try {
      let fromdata = new FormData();
      const token = localStorage.getItem("token");

      fromdata.append("address", emailToSend);
      fromdata.append("subject", " Sharing Study");
      fromdata.append(
        "link",
        `${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`
      );
      const axiosInstance = axios.create({
        baseURL: `${UploadApi}/user/`,
      });
      axiosInstance
        .post("sendEmailLink", fromdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          cogoToast.success("Mail send Successfully.", {
            position: "top-right",
          });
          setModal(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const saveCredentials = (args) => {
    var data = [];
    if (!localStorage.getItem("dcmCredentails")) {
      data.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(data));
    } else {
      data = JSON.parse(localStorage.getItem("dcmCredentails"));
      var filteredData = data.filter((e) => {
        if (e.accession !== args.accession) {
          return e;
        }
      });
      filteredData.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(filteredData));
    }
  };
  const ShareData = () => {
    axios
      .post(`http://192.168.18.19:8080/api/share/CLIENT${state.id}`, {
        patientName: email,
        customerID: state.email,
        expiryDateTime: date,
      })
      .then((response) => response.json())
      .then((result) => console.log("result", result))
      .catch((error) => console.log("error", error));
  };

  const secretKey = "your-secret-key"; // Replace with your secret key

  const encodeBase64UrlSafe = (input) => {
    return btoa(input)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };
  //   const encryptedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
  //   const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
  //   const encryptedDate = CryptoJS.AES.encrypt(date, secretKey).toString();
  // let Foldername = localStorage.getItem("folderName") || "";

  // const encryptedFolderName = CryptoJS.AES.encrypt(Foldername,secretKey).toString();
  const encryptedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
  const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
  const encryptedDate = CryptoJS.AES.encrypt(date, secretKey).toString();

  // let urlSafeFolderName= encryptedFolderName.replace(/\//g, "bbbb");
  let urlSafeEmail = encryptedEmail.replace(/\//g, "bbbb");
  let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
  let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");

  //   //console.log(encryptedEmail, "encryptedEmail");
  //   //console.log(encryptedPass, "encryptedPass");
  //   //console.log(encryptedDate, "encryptedDate");
  //   //console.log(urlSafeEmail, "urlSafeEmail");
  //   //console.log(urlSafePass, "urlSafePass");
  //   //console.log(urlSafeDate, "urlSafeDate");

  //   //console.log("Encrypted Email:", encryptedEmail);
  //   //console.log("Encrypted Password:", encryptedPass);
  //   //console.log("Encrypted Date:", encryptedDate);

  // Decrypt the data
  // const decryptedFolderBytes = CryptoJS.AES.decrypt(encryptedFolderName, secretKey);
  // const decryptedFolder = decryptedFolderBytes.toString(CryptoJS.enc.Utf8);

  const decryptedEmailBytes = CryptoJS.AES.decrypt(encryptedEmail, secretKey);
  const decryptedEmail = decryptedEmailBytes.toString(CryptoJS.enc.Utf8);

  const decryptedPassBytes = CryptoJS.AES.decrypt(encryptedPass, secretKey);
  const decryptedPass = decryptedPassBytes.toString(CryptoJS.enc.Utf8);

  const decryptedDateBytes = CryptoJS.AES.decrypt(encryptedDate, secretKey);
  const decryptedDate = decryptedDateBytes.toString(CryptoJS.enc.Utf8);

  //   //console.log("Decrypted Email:", decryptedEmail);
  //   //console.log("Decrypted Password:", decryptedPass);
  //   //console.log("Decrypted Date:", decryptedDate);
  //   //console.log(
  //     `${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`,
  //     "url"
  //   );
  return (
    <>
      <Dialog
        open={cOpen}
        TransitionComponent={Transition}
        aria-describedby="alert-dialog-slide-description"
        fullScreen={fullScreen}
        PaperProps={{
          style: {
            width: "70%",
            //   border: '1px solid white',
          },
        }}
      >
        <DialogTitle style={{ marginLeft: 5 }}>{"Share files"}</DialogTitle>
        <DialogContent style={{ overflow: "hidden", marginLeft: 5 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "540px",
                }}
              >
                <OutlinedInput
                  margin="normal"
                  required
                  fullWidth
                  label={"link"}
                  variant="outlined"
                  value={`${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`}
                  disabled={true}
                />
              </div>
              <hr />
              <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                <Grid item xs={4}>
                  <br />
                  <TextField
                    hiddenLabel
                    label="Case ID"
                    variant="outlined"
                    disabled={true}
                    size="small"
                    type={"email"}
                    value={email}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 190,
                    }}
                  />
                </Grid>
                <Grid item xs={4} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="password"
                    variant="outlined"
                    size="small"
                    type={"password"}
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 170,
                    }}
                  />
                </Grid>
                <Grid item xs={4} style={{ paddingLeft: 10 }}>
                  <br />
                  <TextField
                    label="Expire Date"
                    InputLabelProps={{ shrink: true, required: true }}
                    variant="outlined"
                    size="small"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    type="date"
                    min={new Date().toISOString().substr(0, 19).split("T")[0]}
                    style={{ borderRadius: "3px", width: 170 }}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
          <Button
            variant="contained"
            disabled={email && pass && date ? false : true}
            onClick={() => setModal(true)}
          >
            Send via email
          </Button>
          <Button
            onClick={() => {
              setCOpen(false);
              setshow(false);

              setPass("");
              setDate("");
            }}
          >
            Back
          </Button>
          <Button
            disabled={email && pass && date ? false : true}
            onClick={() => {
              setshow(!show);
            }}
          >
            Share QR Code
          </Button>

          {show && (
            <QRCode
              size={256}
              bgColor="#000000"
              fgColor="#ffffff"
              style={{
                height: "auto",
                maxWidth: "100%",
                width: "15%",
              }}
              value={`${window.origin}*${pass}*${date}`}
              viewBox={`256 256 256 256`}
            />
          )}
          <CopyToClipboard
            text={`link:${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}
                        email: ${email} 
                        password: ${pass}`}
          >
            <Button
              variant="contained"
              onClick={() => {
                setIsOpen(true);
                ShareData();
                setTimeout(() => {
                  setIsOpen(false);
                }, 2000);
                saveCredentials({
                  accession: cAccession,
                  link: `${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`,
                  CaseID: email,
                  pass: pass,
                });
              }}
              disabled={email && pass && date ? false : true}
            >
              Copy to clipboard
            </Button>
          </CopyToClipboard>
        </DialogActions>
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={"success"}
          message={"Credentials copied to clipboard"}
        />
      </Dialog>

      <Dialog
        open={modal}
        // TransitionComponent={Transition}
        TransitionComponent={Transition}
        style={{ height: "100%" }}
        PaperProps={{
          style: {
            height: "70%",
            //   border: '1px solid white',
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ overflow: "hidden", marginLeft: 5 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "540px",
                }}
              >
                <OutlinedInput
                  margin="normal"
                  required
                  fullWidth
                  label={"link"}
                  variant="outlined"
                  value={`${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`}
                  disabled={true}
                />
              </div>
              <hr />
              <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                {/* <Grid item xs={4} >
                                  
                                    
                                <br/>
                                    <TextField hiddenLabel label='Case ID'  variant='outlined' disabled={true} size="small" type={"email"} value={email}  style={{ borderRadius: "3px" , backgroundColor:'white',width:190}} />
                                </Grid> */}
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Email"
                    variant="outlined"
                    size="small"
                    type={"email"}
                    value={emailToSend}
                    onChange={(e) => setEmailToSend(e.target.value)}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Subject"
                    variant="outlined"
                    size="small"
                    type={"text"}
                    value={"Sharing Study"}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
          {/* <Button variant="contained" disabled={email && pass && date ? false : true} onClick={()=>setModal(true)} >Share with email</Button> */}
          <Button onClick={() => setModal(false)}>Back</Button>
          <Button variant="contained" onClick={() => SendEmail()}>
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
